import api from "./api";

const user: {
  access: {
    [x: string]: boolean;
  };
} = {
  access: {},
};

function whoAmI() {
  return api
    .get("/whoami" + window.location.pathname + window.location.search, {
      validateStatus: () => true,
    })
    .then((response) => {
      if (response.status === 401) {
        if (response.data.redirect) {
          return window.location.replace(response.data.redirect);
        }
        return false;
      } else if (response.data.redirect) {
        return window.location.replace(response.data.redirect);
      } else {
        Object.assign(user, response.data.data);
        return user;
      }
    });
}

function withAllOf(...keys: any[]) {
  for (const key of keys) {
    if (!user.access[key]) {
      return false;
    }
  }
  return true;
}

function logout() {
  return api.post("/logout");
}

const Interface = {
  user,
  whoAmI,
  logout,
  withAllOf,
};

export default Interface;

// export function getVerifyProviders() {
//   return api.get('/verify/providers')
//   .then((response) => response.data.data);
// }

// export function getVerifyAuthenticatorImageUrl() {
//   return '/api/v0/verify/authenticator/generate';
// }

// export function pairVerifyAuthenticator(code: string) {
//   return api.post('/verify/authenticator/pair', {code})
// }

// export function verifyAuthenticator(code: string) {
//   return api.post('/verify/authenticator/verify', {code})
// }
